import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AccessRole, LocalService } from 'lib-base';


export const isAuthenticatedGuard = (): CanActivateFn => {
  return (route, state) => {
    const localService = inject(LocalService);
    const router = inject(Router);
    if (localService.isLoggedIn) {
      if(localService.hasRole(AccessRole.GESTION_TRAMITE)){      
        router.navigate(["configuracion/landing"]);
      }else if(localService.hasRole(AccessRole.ADMIN_TRAM)){
        router.navigate(["configuracion/gestion-tramites"]);
      }else if(localService.hasRole(AccessRole.GESTION_PQRSD)){
        router.navigate(["configuracion/mis-pqrsd"]);
      }else if(localService.hasRole(AccessRole.ADMIN_PQRSD)){
        router.navigate(["configuracion/gestion-pqrsd"]);
      }
      return false;
    }
    return true;
  };
};

